<template>
    <div class="case">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in 54" :key="index">
                    <img class="img_slide" :src="'https://library-h5.oss-cn-hangzhou.aliyuncs.com/'+(index+1)+'.png'" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
export default {
    mounted(){
        new Swiper ('.swiper-container', {
            loop: true
        })
    }
}
</script>
<style scoped>
.case,
.img_slide{
    width: 100%;
    height: 100%;
}
.swiper-container {
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/case.vue